import { Route, Routes } from 'react-router-dom';
import Home from './Home';
import TermsOfService from './TermsOfService';
import PrivacyPolicy from './PrivacyPolicy';
import { ScrollToTop } from './components';
import './App.css';

/**
 * Main App component with routing
 */
function App() {
	return (
		<>
			<ScrollToTop />
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/terms-of-service" element={<TermsOfService />} />
				<Route path="/privacy-policy" element={<PrivacyPolicy />} />
			</Routes>
		</>
	);
}

export default App;
